import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
import { searchFormItems } from './config';
import LogDetails from './LogDetails.vue';
import { PAGE_URL } from '@/api/system/sys-log';
import { formatterDate } from '@/utils/common';
import { XTable } from '@/components/index';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Log',
  setup(__props) {
    const tableInstance = ref();
    const LogDetailsRef = ref();
    const headerButton = [];
    function search(formData) {
      let searchFormData = {
        ...formData
      };
      if (searchFormData.timeRange) {
        searchFormData.timeRange = formData.timeRange[0] + ',' + formData.timeRange[1];
      }
      console.error(searchFormData);
      tableInstance.value?.load(searchFormData);
    }
    function reset() {
      tableInstance.value?.load({});
    }
    function details(row) {
      LogDetailsRef.value?.open(row);
    }
    return (_ctx, _cache) => {
      const _component_XSearchForm = _resolveComponent("XSearchForm");
      const _component_ElTableColumn = _resolveComponent("ElTableColumn");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_XFlexCtx = _resolveComponent("XFlexCtx");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createVNode(_component_XSearchForm, {
          ref: "searchForm",
          items: _unref(searchFormItems),
          onSearch: search,
          onReset: reset
        }, null, 8, ["items"]), _createVNode(_component_XFlexCtx, {
          flex: 1
        }, {
          default: _withCtx(() => [_createVNode(_unref(XTable), {
            ref_key: "tableInstance",
            ref: tableInstance,
            url: _unref(PAGE_URL),
            "show-index": "",
            selectable: "",
            "header-buttons": headerButton,
            "el-table-props": {
              border: true
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_ElTableColumn, {
              label: "功能模块",
              prop: "module",
              width: "150"
            }), _createVNode(_component_ElTableColumn, {
              label: "操作描述",
              prop: "message",
              width: "250"
            }), _createVNode(_component_ElTableColumn, {
              label: "请求地址",
              prop: "reqUrl",
              width: "250"
            }), _createVNode(_component_ElTableColumn, {
              label: "操作用户",
              prop: "username",
              width: "100"
            }), _createVNode(_component_ElTableColumn, {
              label: "操作耗时(ms)",
              prop: "takeUpTime",
              width: "120",
              align: "right"
            }), _createVNode(_component_ElTableColumn, {
              label: "请求IP",
              prop: "reqIp",
              width: "160"
            }), _createVNode(_component_ElTableColumn, {
              label: "操作状态",
              prop: "resultType",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [row.resultType === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                type: "success"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" 正常 ")])),
                _: 1
              })) : row.resultType === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                type: "danger"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 异常 ")])),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_ElTableColumn, {
              label: "创建时间",
              prop: "createdAt",
              align: "center",
              formatter: row => _unref(formatterDate)(row.createdAt)
            }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
              label: "操作",
              width: "150",
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_link, {
                underline: false,
                icon: "search",
                type: "primary",
                onClick: $event => details(row)
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("span", {
                  style: {
                    "padding": "0 6px 0 4px"
                  }
                }, "查看详情", -1)])),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["url"])]),
          _: 1
        }), _createVNode(LogDetails, {
          ref_key: "LogDetailsRef",
          ref: LogDetailsRef
        }, null, 512)]),
        _: 1
      });
    };
  }
});